import script from "./FAIcon.vue?vue&type=script&lang=ts"
export * from "./FAIcon.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__